import type { IDocumentAnnotation } from '@apis/documentAnnotations';
import { formatProjectDateTime } from '@utils/formatProjectDate';
import styles from './AttributionChip.module.css';

interface IAttributionChipProps {
  annotation: IDocumentAnnotation;
  tz: string | null;
  x: number;
  y: number;
}

/**
 * Who drew the mark under the pointer, and when. Attribution needs no per-item
 * author: an item belongs to exactly one annotation, so the annotation's author
 * is the item's author (ADR-0013).
 */
export function AttributionChip({ annotation, tz, x, y }: IAttributionChipProps) {
  return (
    <div
      className={styles.chip}
      role="status"
      style={{ left: Math.min(x + 14, window.innerWidth - 260), top: y + 18 }}
    >
      <span className={styles.author}>{annotation.createdBy.name}</span>
      <span className={styles.when}>{tz ? formatProjectDateTime(annotation.createdAt, tz) : '—'}</span>
      {annotation.note && <span className={styles.note}>{annotation.note}</span>}
    </div>
  );
}
